export default __webpack_public_path__ + "static/media/Rectangle-129.1e8635c7.png";